import React, { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { ConfirmationOfApplication } from '@/features/ui/Steps/ConfirmationOfApplication';
import { useProceedNextFromConfirmation } from '@/features/ui/Steps/ConfirmationOfApplication/utils/useProceedNextFromConfirmation';

import { StepControlPanel, Typography, Link, ConditionView } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { ROUTES } from '@/router/config';

import { CitizenAppealMergedSchema } from '../../model/types';

import { DescriptionOfRequestPreview } from './DescriptionOfRequest';
import { PersonalDataPreview } from './PersonalData';
import { ResidenceAddressPreview } from './ResidenceAddress';

export interface DataPreviewProps {
  handleGeneratePDF: (formData: CitizenAppealMergedSchema) => Promise<void>;
}

export const DataPreview: React.FC<StepProps<DataPreviewProps>> = ({ next, prev, handleGeneratePDF }) => {
  const { control, getValues } = useFormContext<CitizenAppealMergedSchema>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { proceedNextFromConfirmation } = useProceedNextFromConfirmation(next);

  const confirmEnteredDataCorrect = useWatch({
    control,
    name: 'confirmEnteredDataCorrect',
  });

  const handleNextStep = async (): Promise<void> => {
    setIsLoading(true);

    handleGeneratePDF(getValues())
      .then(proceedNextFromConfirmation)
      .catch((error) => console.error(error))
      .finally(() => setIsLoading(false));
  };

  return (
    <ConditionView if={!isLoading} else={<Loader />}>
      <FormBlock title="Підтвердження даних" className="form-block__data-preview">
        <PersonalDataPreview />
        <ResidenceAddressPreview />
        <DescriptionOfRequestPreview />
      </FormBlock>

      <ConfirmationOfApplication
        confirmLabelElement={
          <Typography>
            Я підтверджую правильність даних та ознайомлений з{' '}
            <Link isExternal to={ROUTES.PERSONAL_DATA}>
              політикою обробки персональних даних
            </Link>
          </Typography>
        }
      />

      <StepControlPanel prev={prev} next={handleNextStep} disabledNext={!confirmEnteredDataCorrect} />
    </ConditionView>
  );
};
